import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { SelectSlabCommissionByOperatorID as SLAB_DETAILS } from 'Components/Api/SlabDetailApi';
import { useHistory } from 'react-router';
import { LOGOUT } from 'ConstComponents';
import { Last10RechargeReport } from 'Pages/InnerPages/Report/Last10RechargeReport';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    Container,
    Grid,
    Paper,
    MenuItem,
    CircularProgress,
    Button,
    Box
} from '@material-ui/core';
import { CouponBuy as COUPON_BUY } from 'Components/Api/PanMitraAPI';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID,
    PANCARD_CODE,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);

export const CouponBuy = () => {
    const history = useHistory();
    const classes = commonStyle();
    const formRef = useRef();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [severity, setSeverity] = useState('success');
    const [Operator, setOperator] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [RefreshRandom, setRefreshRandom] = useState(0);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [FormObj, setFormObj] = useState({
        ServiceID: PANCARD_CODE,
        OperatorID: '0',
        Qty: '0',
        Charge: '0'
    });

    const handleSubmit = async (values, { resetForm }) => {
        let op = Operator.filter((o) => o.OperatorID === values.OperatorID);

        values.OperatorName = op[0].OperatorName;
        values.OperatorImagePath = op[0].Path;
        values.Charge = values.Charge * values.Qty;
        setIsAlertOpen(true);
        setConfirmAlertRequest(values);
    };

    const Buying = async (values) => {
        if (loading) {
            setLoading(false);
            return;
        }
        var requestObj = JSON.stringify(values);
        setIsError(false);
        setLoading(true);
        var response = await COUPON_BUY(requestObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        setRefreshRandom(Math.random(0));
        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }
        setSeverity('success');
        setFormObj({
            OperatorID: 0,
            Qty: '0',
            Charge: '0'
        });
        setTimeout(() => {}, MESSAGE_CLOSE_AFTER);
    };
    const OnDetailChange = async (name, value, setFieldValue) => {
        var OperatorID = value; //event.target.value;
        setFieldValue(name, value);
        selectDetail(OperatorID);
    };
    const selectDetail = async (OperatorID) => {
        let JSONObj = {
            OperatorID: OperatorID
        };
        var request = JSON.stringify(JSONObj);
        setLoading(true);
        const response = await SLAB_DETAILS(request);
        if (!response.isAuthorized) LOGOUT();
        var data = JSON.parse(response.data);
        setLoading(false);
        setFormObj({
            ...FormObj,
            Charge: data.Commission,
            OperatorID: formRef.current.values.OperatorID
        });
    };
    const selectOperator = async () => {
        var requestObj = {
            ServiceID: PANCARD_CODE
        };
        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };

    const FormValidationSchema = Yup.object({
        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator'),
        Qty: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'qty')
            .min(1, PLEASE_PROVIDE_VALID + 'qty')
            .max(100, PLEASE_PROVIDE_VALID + 'qty')
    });

    useEffect(() => {
        selectOperator();
    }, []);

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={FormObj}
            >
                {({ setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Grid container spacing={2}>
                                            <Grid xs={12} sm={12} md={6} lg={6}>
                                                {' '}
                                                <Grid
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <h2
                                                        className={
                                                            classes.PaperHead_h2
                                                        }
                                                    >
                                                        Coupon Buy
                                                    </h2>
                                                </Grid>
                                            </Grid>
                                            <Grid xs={12} sm={12} md={6} lg={6}>
                                                <Box
                                                    className={
                                                        classes.flexReverse
                                                    }
                                                >
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        onClick={() => {
                                                            history.push(
                                                                '/VleRegistration'
                                                            );
                                                        }}
                                                    >
                                                        Vle Registration
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialSelect
                                                        label="Operator"
                                                        name="OperatorID"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            OnDetailChange(
                                                                name,
                                                                value,
                                                                setFieldValue
                                                            );
                                                        }}
                                                    >
                                                        <MenuItem
                                                            key="0"
                                                            value="0"
                                                        >
                                                            Select Operator
                                                        </MenuItem>
                                                        {Operator.map(
                                                            (Item) => (
                                                                <MenuItem
                                                                    key={
                                                                        Item.OperatorID
                                                                    }
                                                                    value={
                                                                        Item.OperatorID
                                                                    }
                                                                >
                                                                    {
                                                                        Item.OperatorName
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </MaterialSelect>
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Charge Per Qty"
                                                        name="Charge"
                                                        type="text"
                                                        placeholder="Charge Per Qty"
                                                        readOnly={true}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        label="Qty"
                                                        name="Qty"
                                                        type="text"
                                                        placeholder="Qty"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <SecondaryButton
                                                        type="reset"
                                                        variant="contained"
                                                        color="secondary"
                                                        title="Reset"
                                                        className={
                                                            classes.CustomDangerButtonStyle
                                                        }
                                                    >
                                                        Reset
                                                    </SecondaryButton>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <PrimaryButton
                                                        type="submit"
                                                        title="Buy"
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        disabled={loading}
                                                    >
                                                        Buy
                                                    </PrimaryButton>
                                                    {loading && (
                                                        <CircularProgress
                                                            size={24}
                                                            className={
                                                                classes.buttonProgress
                                                            }
                                                        />
                                                    )}
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                lg={6}
                                                style={{
                                                    marginTop: '10px'
                                                }}
                                            >
                                                <a
                                                    href="https://panmitra.com/portallogin/apidocs.php"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Login Pan Mitra
                                                </a>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                </Form>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="lastrecharges"
                            >
                                <Last10RechargeReport
                                    ServiceID={PANCARD_CODE}
                                    refreshRandom={1}
                                />
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="Coupon Buy"
                    message="Are you sure to do buy?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Buying(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
